import { Component, OnInit } from '@angular/core';
import { SettlementServiceService } from '../../../services/raintree/Transmission/settlement-service.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MandirBillFilterComponent } from '../mandir-bill-filter/mandir-bill-filter.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { WorkerViewComponent } from './worker-view/worker-view.component';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { BillDetailsComponent } from './bill-details/bill-details.component';
import { log } from 'node:console';

@Component({
  selector: 'app-mandir-bill',
  standalone: true,
  imports: [ReactiveFormsModule,LoaderComponent],
  templateUrl: './mandir-bill.component.html',
  styleUrl: './mandir-bill.component.scss',
})
export class MandirBillComponent implements OnInit {
  unSettledMandir: mandirDetails[] = [];
  pageNo: number = 1;
  searchCode = new FormControl('')
  workerData: any[] = [];
  isLoading: boolean = false;


  constructor(
    private settledService: SettlementServiceService,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getMandirDetails({pageno: this.pageNo});
    this.searchCode.valueChanges.subscribe(val => {
      if (val?.trim() === '') {
        this.getMandirDetails({pageno: this.pageNo});
      }
    })
    // this.unSettledMandir = dummyData;
  }
  resFilter: any;
  onClickFilter() {
    const dialogRef = this.dialog.open(MandirBillFilterComponent, {
      width: '620px',
      panelClass: 'custom-dialog-container',
      data: this.resFilter,
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this.getMandirDetails({
            pageno: this.pageNo,
            fy: res?.financeYear,
            uiState: res?.state,
            uiDistrict: res?.district
          })
          this.resFilter = {
            fy: res.financeYear,
            state: res.state,
            district: res.district,
            isAllDistrict: res.isAllDistrict
          }
        } else {
          this.getMandirDetails({pageno: this.pageNo});
        }
      }
    })
  }

  getMandirDetails(queryParams: any) {
    this.isLoading = true;
    this.settledService.getUnsettledMandir(queryParams).subscribe({
      next: (res) => {
        this.isLoading = false;
        console.log(res);

        this.unSettledMandir = res.data;
        console.log('Data mil gaya', this.unSettledMandir);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err.message);
      },
    });
  }

  getMandirByCode() {
    const val=this.searchCode.value?.trim()
    if (val && val.length>0) {
      this.getMandirDetails({
        pageno: this.pageNo,
        mandircode: this.searchCode.value
      });
    };
    
    console.log(this.searchCode.value);
    
  }

  viewWorker(code: any) { 
    this.isLoading = true;
      // getWorkerDetails(queryParams:string) {
    this.settledService.getWorkerDetails({mandircode: code}).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.workerData = res.data.workers;
        console.log(this.workerData)
        if(this.workerData.length > 0){
      const dialogRef = this.dialog.open(WorkerViewComponent, {
      width: '620px',
      panelClass: 'custom-dialog-container',
      data: this.workerData,
    });
  }else{
    this.toastr.error('No worker records found')
  }
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err.message);
        
      }
    })
  }
    // console.log(row,'seleted row data');   
    // const dialogRef = this.dialog.open(WorkerViewComponent, {
    //   width: '620px',
    //   panelClass: 'custom-dialog-container',
    //   data: row,
    // });

  formatIndianCurrency(amount: string | number): string {
    const number = Number(amount);
    if (isNaN(number)||null) return '--';

    return (
      '₹ ' +
      number.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  openBillDetails() {
    // const dialogRef = this.dialog.open(BillDetailsComponent, {
    //   width: '620px',
    //   panelClass: 'custom-dialog-container',
    //   // data: ,
    // });
    // dialogRef.afterClosed().subscribe({
    //   next:(res)=>{}
    // })
  }
 
}
  


interface mandirDetails {
  scoa_name: string;
  scoa_code: string;
  state_name: string;
  district_name: string;
  total_advance_given: string;
  total_bill_payment: string;
  remaining_amount: string;
  last_advance_date: string;
  last_bill_receive_date: null;
}
